import { enUS, ru } from "date-fns/locale";

import { currentLocale } from "src/i18n/hosts";

/**
 * Локаль date-fns под язык версии сайта (домен). Используется для подписей
 * дат на графике и в календаре — иначе на английской версии месяцы
 * отрисовывались бы по-русски.
 */
export const dateFnsLocale = currentLocale === "en" ? enUS : ru;
